  import defaultClient from '@src/api/clients/default';

  const URL = (path) => {
    return `dashboard/daily-pulse/${path}/`
  }

  export function fetchDailyPulseByClient(payload = {}) {
    return defaultClient.request({
      url: URL('client'),
      payload
    })
  }

  export function fetchDailyPulseByChannel(payload = {}) {
    return defaultClient.request({
      url: URL('channel'),
      payload
    })
  }

  export function fetchDailyPulseByVertical(payload = {}) {
    return defaultClient.request({
      url: URL('vertical'),
      payload
    })
  }

  export function fetchDailyPulseByCampaign(payload = {}) {
    return defaultClient.request({
      url: URL('campaign'),
      payload
    })
  }

  export function fetchDailyPulseByClientDate(payload = {}) {
    return defaultClient.request({
      url: URL('client-date'),
      payload
    })
  }

  export function fetchDailyPulseByState(payload = {}) {
    return defaultClient.request({
      url: URL('state'),
      payload
    })
  }

  export function fetchDailyPulseByCity(payload = {}) {
    return defaultClient.request({
      url: URL('city'),
      payload
    })
  }

  export function fetchDailyPulseByCounty(payload = {}) {
    return defaultClient.request({
      url: URL('county'),
      payload
    })
  }

  export function fetchDailyPulseByDMA(payload = {}) {
    return defaultClient.request({
      url: URL('dma'),
      payload
    })
  }

  export function fetchDailyPulseByTerritory(payload = {}) {
    return defaultClient.request({
      url: URL('territory'),
      payload
    })
  }

  export function fetchDailyPulseByTerritoryCampaign(payload = {}) {
    return defaultClient.request({
      url: URL('territory-campaign'),
      payload
    })
  }

  export function triggerDailyPulseBackfill(payload = {}) {
    return defaultClient.request({
      url: URL('collect-report-range'),
      method: 'POST',
      payload,
    })
  }

  export function fetchDailyPulseBackfillStatus(payload = {}) {
    return defaultClient.request({
      url: URL('collect-report-range/status'),
      method: 'GET',
      payload,
    })
  }

  export function triggerBackendSummaryBackfill(payload = {}) {
    return defaultClient.request({
      url: URL('backend-summary-backfill'),
      method: 'POST',
      payload,
    })
  }

  export function fetchBackendSummaryBackfillStatus(payload = {}) {
    return defaultClient.request({
      url: URL('backend-summary-backfill/status'),
      method: 'GET',
      payload,
    })
  }

  export function triggerLeadCzvBackfill(payload = {}) {
    return defaultClient.request({
      url: URL('lead-czv-backfill'),
      method: 'POST',
      payload,
    })
  }

  export function fetchLeadCzvBackfillStatus(payload = {}) {
    return defaultClient.request({
      url: URL('lead-czv-backfill/status'),
      method: 'GET',
      payload,
    })
  }

  export function triggerFacebookSummaryBackfill(payload = {}) {
    return defaultClient.request({
      url: URL('facebook-summary-backfill'),
      method: 'POST',
      payload,
    })
  }

  export function fetchFacebookSummaryBackfillStatus(payload = {}) {
    return defaultClient.request({
      url: URL('facebook-summary-backfill/status'),
      method: 'GET',
      payload,
    })
  }

  export function triggerDashboardDataDeletion(payload = {}) {
    return defaultClient.request({
      url: URL('delete-dashboard-data'),
      method: 'POST',
      payload,
    })
  }

  export function fetchDashboardDataDeletionStatus(payload = {}) {
    return defaultClient.request({
      url: URL('delete-dashboard-data/status'),
      method: 'GET',
      payload,
    })
  }

  export function triggerBackendDataDeletion(payload = {}) {
    return defaultClient.request({
      url: URL('delete-backend-data'),
      method: 'POST',
      payload,
    })
  }

  export function fetchBackendDataDeletionStatus(payload = {}) {
    return defaultClient.request({
      url: URL('delete-backend-data/status'),
      method: 'GET',
      payload,
    })
  }
